/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  ActionIcon, Form, FormHandlers, Grid, ICON_CLOSE, Message,
} from '@doveit/bricks';
import AgentAutoComplete from '../../../containers/agent-autocomplete/AgentAutoComplete';
import { AgentStatus, ReferenceType } from '../../../domain/types';
import { Agent } from '../../../providers/api/dtos';
import { ViewAgentSmallPreview } from '../../../agent/components';
import { toAgentPreviewProps } from '../../../agent/mappers/toAgentPreviewProps';
import { goToDetailPage } from '../../../utils/navigate/utils';
import * as styles from './AgencyTeamForm.style';

export interface AgencyTeamFormModel {
  agents: Agent[],
}
export interface AgencyTeamFormProps {
  onSubmit: (data: AgencyTeamFormModel) => void,
  initialValues?: AgencyTeamFormModel,
  innerRef?: React.MutableRefObject<FormHandlers>,
  loading?: boolean,
}

const AgencyTeamForm: React.FC<AgencyTeamFormProps> = ({
  initialValues,
  innerRef,
  onSubmit,
  loading = false,
}) => {
  const goToAgentPage = React.useCallback((agentId: NonNullable<Agent['id']>) => () => {
    goToDetailPage(agentId, ReferenceType.AGENT);
  }, []);

  return (
    <Form
      initialValues={initialValues || { agents: [] }}
      onSubmit={onSubmit}
      innerRef={innerRef}
      loading={loading}
    >
      {({ values }) => (
        <Form.FieldArray
          name="agents"
          render={({ push, remove }) => (
            <>
              <Form.Item size={{ MD: 1 / 2 }}>
                <AgentAutoComplete
                  clearValueOnSelection
                  excludeAgentsByEmail={values.agents.map((a) => a.email.work || a.email.personal || '')}
                  label="Aggiungi agente"
                  aria-label="Campo per aggiungere un agente al team"
                  placeholder="Cerca per nome"
                  status={AgentStatus.ACTIVE}
                  onSuggestionSelected={(agent) => {
                    if (values.agents.find((a) => a.id === agent?.id)) {
                      return;
                    }

                    push(agent);
                  }}
                />
              </Form.Item>
              <Form.Fieldset legend="Componenti aggiunti">
                <Form.Item>
                  {values.agents.length === 0 && (
                    <Message message="Nessun agente aggiunto al team." />
                  )}
                  {values.agents.length > 0 && (
                    <Grid gutter={75}>
                      {values.agents.map((agent) => (
                        <Grid.Unit
                          key={agent.id}
                          size={{ MD: 1 / 2 }}
                        >
                          <div css={styles.agentSelectionWrapper}>
                            <ViewAgentSmallPreview
                              {...toAgentPreviewProps(agent)}
                              aria-label="Anteprima agente selezionato"
                              onClick={goToAgentPage(agent.id!)}
                            />
                            <div css={styles.agentRemoveAction}>
                              <ActionIcon
                                label="Rimuovi agente dal team"
                                aria-label="Azione per rimuovere l'agente dal team"
                                onClick={() => remove(values.agents.findIndex((a) => a.id === agent.id))}
                                size="XS"
                                icon={{ path: ICON_CLOSE }}
                              />
                            </div>
                          </div>
                        </Grid.Unit>
                      ))}
                    </Grid>
                  )}
                </Form.Item>
              </Form.Fieldset>
            </>
          )}
        />
      )}
    </Form>
  );
};

export default AgencyTeamForm;
